import React, {createContext} from 'react';
const ProductPageContext = createContext(null);
/**
 * ProductPageContext value:
 * {
 *   ...
 *   group: object | null,
 *   setGroup: (group: object | null) => void,
 *   parentGroup: object | null,
 *   ...
 * }
 */
export {ProductPageContext};